import React from 'react'
import { useLocation } from 'react-router-dom'

// TODO Переделать в хук 

const HashLinkScroll = () => {

    const currentLocation = useLocation();
    
    const [hashElement, setHashElement] = React.useState(null);

    const removeHashChar = hashName => hashName.slice(1) ;

    React.useEffect ( () => {

        let hashElementName = currentLocation.hash;

        if (hashElementName) {
            setHashElement(document.getElementById(removeHashChar(hashElementName)));
        } 

    }, [currentLocation] )

    React.useEffect( () => {
        if (hashElement) {
            hashElement.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }, [hashElement] )
}

export default HashLinkScroll;